import React, { useState } from 'react';
import { Card, CardContent, Typography, Button, Grid, Box, CircularProgress } from '@mui/material';
import { styled } from '@mui/system';
import { Post, apiURL } from '../../../utils/apiCalls';
import { toast } from 'react-toastify';
import RenderRazorpay from '../agents/RenderRazorpay';

const SubscriptionPage = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [orderDetails, setOrderDetails] = useState({
    orderId: null,
    currency: null,
    amount: null,
  });
  const [loader, setLoader] = useState(null);  // Track loader for specific plan
  const [displayRazorpay, setDisplayRazorpay] = useState(false);
  const [account, setAccount] = useState();
  const [logoutPage,setLogoutPage] = useState(false)

  React.useMemo(() => {
    setAccount(JSON.parse(sessionStorage.getItem('user_details')));
  }, [sessionStorage.getItem('user_details')]);

  React.useMemo(() => {
    setLogoutPage(sessionStorage.getItem('subscription'));
  }, [sessionStorage.getItem('subscription')]);
  console.log(account,"accountaccountaccount")

  // Price mapping for different level codes
const levelCodePrices = {
  1: 4999, // Director
  2: 3999, // President
  3: 2999, // Vice President
  4: 2499, // CGM
  5: 3499, // GM
  6: 1499, // DGM
  7: 2999, // AGM
  8: 999,  // Sr. Manager
  9: 1999, // Manager
  10: 1499, // Asst. Manager
  11: 999,  // Team Leader
  12: 699,  // Senior Property Advisor
  13: 499,  // Property Advisor
};

  const levelCode = account?.role?.level_code;
  const plans = levelCode && levelCode >= 1 && levelCode <= 14
    ? [{ id: 1, name: '12 Months', price: levelCodePrices[levelCode], month: 12 }]
    : [
        { id: 4, name: '12 Months', price: 299, month: 12 },
        { id: 3, name: '9 Months', price: 259, month: 9 },
        { id: 2, name: '6 Months', price: 179, month: 6 },
        { id: 1, name: '3 Months', price: 99, month: 3 }
      ];

  const handleCallBack = (response) => {
console.log(response,"logoutPage")

    if(response=='SUCCESS'){
      setDisplayRazorpay(false)
      setLogoutPage(true)
      setLoader(null);
    }
  }

  const handleSelectPlan = async (plan) => {
    setSelectedPlan(plan);
    setLoader(plan.id);  // Set loader only for the selected plan

    const response = await Post(apiURL + '/api/v1/payments/sub_payment_order', { amount: plan.price, month: plan.month });

    if (response && response.data && response.data.status) {
      setOrderDetails({
        orderId: response.data.data.order_id,
        currency: response.data.data.currency,
        amount: response.data.data.amount,
      });
      setDisplayRazorpay(true);
    } else {
      toast.error(response?.data.message || 'Please Try Again');
    }

    setLoader(null);  // Reset loader after receiving response
  };

  return (
    <Box sx={{ padding: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#f0f0f0', minHeight: '100vh' }}>
      {!logoutPage?<><Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
        Choose Your Subscription Plan
      </Typography>
      <Grid container spacing={4} justifyContent="center">
      {plans.map((plan, index) => (
  <Grid item key={plan.id}>
    <StyledCard onClick={() => handleSelectPlan(plan)} selected={selectedPlan?.id === plan.id}>
      <CardContent sx={{ position: 'relative' }}>
        {index === 0 && (
          <Box
            sx={{
              backgroundColor: '#1976d2',  // Blue background
              color: '#fff',
              padding: '4px 12px',
              borderRadius: '20px',
              position: 'absolute',
              top: '8px',
              left: '8px',
              fontSize: '12px',
              fontWeight: 600,
              zIndex: 1,
            }}
          >
Reccommend
          </Box>
        )}

        <Typography variant="h5" component="div" align="center" sx={{ fontWeight: 600, paddingTop: index === 0 ? '40px' : 0 }}>
          {plan.name}
        </Typography>
        <Typography variant="h6" align="center" color="textSecondary" gutterBottom>
          ₹{plan.price}
        </Typography>
        <div align="center" style={{ paddingBottom: '10px' }}>
          This plan includes full access to all the platform's features.
        </div>

        {loader === plan.id ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', padding: 2 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Button
            variant="contained"
            fullWidth
            disabled={loader !== null && loader !== plan.id}  // Disable other buttons while loader is active
            sx={{
              backgroundColor: '#1976d2', // Default blue color
              '&:hover': { backgroundColor: '#1565c0' },
              fontWeight: 600,
              borderRadius: '30px',
              padding: '12px',
            }}
          >
            Subscribe
          </Button>
        )}
      </CardContent>
    </StyledCard>
  </Grid>
))}


      </Grid>
      
      </>:(
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '40px' }}>
    <Typography variant="h5" gutterBottom>
      Please log in to access the subscription plans.
    </Typography>
    <Button
      variant="outlined"
      sx={{
        backgroundColor: '#1976d2', // Blue color
        '&:hover': { backgroundColor: '#1565c0' },
        color: '#fff',
        fontWeight: 600,
        borderRadius: '30px',
        padding: '12px',
      }}
      onClick={() => window.location.href = '/#/login'} // Redirect to login page
    >
      Log In
    </Button>
  </Box>
)}

      {displayRazorpay && (
        <RenderRazorpay
          amount={orderDetails.amount}
          currency={orderDetails.currency}
          orderId={orderDetails.orderId}
          keyId={'rzp_live_T0Fj5jdM5C2Q6F'}
          keySecret={''}
          email={account.email}
          phone={account.phone}
          page={'subcription'}
          handleCallBack={handleCallBack}
        />
      )}

      <Box sx={{ marginTop: 4, padding: 2, backgroundColor: '#fff', borderRadius: '8px', boxShadow: 2, width: '100%', maxWidth: '800px' }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
          Subscription Terms & Conditions
        </Typography>
        <Typography variant="body2" color="textSecondary">
          1) Subscription fee is not for the food expenses, travel expenses, bonuses, recruitment expenses.
        </Typography>
        <Typography variant="body2" color="textSecondary">
          2) Only for subscription for membership in a particular year, that is for up to period.
        </Typography>
        <Typography variant="body2" color="textSecondary">
          3) We are not giving a guarantee for sales assurance, income assurance, that is completely dependent on your performance, market conditions, and consumer behavior.
        </Typography>
        <Typography variant="body2" color="textSecondary">
          4) Company is not responsible for any loss or damage.
        </Typography>
        <Typography variant="body2" color="textSecondary">
          5) The company has the rights to change or modify anything at any time.
        </Typography>
      </Box>
    </Box>
  );
};

// Styled components for a premium card appearance
const StyledCard = styled(Card)(({ selected }) => ({
  width: 340,
  cursor: 'pointer',
  border: `2px solid ${selected ? '#1976d2' : '#dcdcdc'}`, // Grey border when unselected
  borderRadius: '16px',  // Rounded corners
  transition: 'transform 0.3s, box-shadow 0.3s',
  boxShadow: selected
    ? `0px 8px 25px rgba(0, 0, 0, 0.2)`
    : `0px 6px 15px rgba(0, 0, 0, 0.15)`,
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: `0px 12px 30px rgba(0, 0, 0, 0.25)`,
    backgroundColor: '#fff',  // Keep white background on hover
  },
  backgroundColor: '#fff', // White background for the card
  color: '#000',  // Text color black for better readability
  padding: '16px',
}));

export default SubscriptionPage;
